import SectionTopBg1 from '@/assets/img/tmp/bg_youtube1.png';
import SectionTopBg1M from '@/assets/img/tmp/bg_youtube1M@2x.png';
import { breakpoint } from '@/helpers/BreakpointHelper';
import React, { FC, HTMLAttributes } from 'react';
import styled from 'styled-components';
import 'swiper/components/navigation/navigation.min.css';
import 'swiper/components/pagination/pagination.min.css';
import 'swiper/components/scrollbar/scrollbar.min.css';

const PanelContainer = styled.div`
  max-width: 1120px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;

  .btn-container {
    margin-bottom: 32px;
    width: 100%;
    //overflow-x: hidden;
    z-index: 1;

    .UiTabPanel {
      //display: inline-flex;
      text-align: left;
      margin-top: -16px;

      & > li {
        padding: 0;
        display: inline-block;
        margin: 0 16px 16px 0;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }

    ${breakpoint(`tablet`)} {
      margin-bottom: 48px;
    }
  }
`;
const VideoContainer = styled.div`
  width: 100%;
  position: relative;
  &::before {
    content: '';
    display: block;
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translate(-50%, 0);
    background: url(${SectionTopBg1}) center top no-repeat;
    background-size: auto 100%;
    width: 1920px;
    height: 710px;
    
    ${breakpoint(1160)} {
      height: 61.21vw;
    }
  }
  &.together::before {
    display: none;
  }
  
  .video-wrap {
    width: 100%;
    max-width: 1120px;
    margin: 0 auto;
    /* padding-top: 66.69%; */
    padding-top: 56.25%;
    position: relative;
  }
  .video {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }

  ${breakpoint(`tablet`)} {
    &::before {
      width: auto;
      height: 0;
      padding-top: 69.44%;
      background-image: url(${SectionTopBg1M});
      background-size: cover;
      left: -20px;
      right: -20px;
      transform: translate(0, 0);
    }
  }
`;
const YoutubeContainer = styled.div`
  h2 {
    padding-bottom: 96px;
  }

  ${breakpoint(`tablet`)} {
    h2 {
      padding-bottom: 72px;
    }
  }
`;

interface YoutubeSingleProps extends HTMLAttributes<HTMLDivElement> {
  title?: string;
  src?: string;
  videoId?: string;
  iframeProps?: any;
  addClass?: string;
}

const YoutubeSingle = styled<FC<YoutubeSingleProps>>(
  ({ title = `YouTube video player`, src, videoId, iframeProps, addClass, ...props }) => (
    <YoutubeContainer {...props}>
      <PanelContainer>
        <VideoContainer className={addClass}>
          <div className="video-wrap">
            <iframe
              {...iframeProps}
              src={
                src ||
                `https://www.youtube.com/embed/${videoId}?controls=1&modestbranding=1&rel=0&enablejsapi=1`
              }
              className="video"
              title={title}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </VideoContainer>
      </PanelContainer>
    </YoutubeContainer>
  ),
)``;

export default YoutubeSingle;
